import {Routes} from "@angular/router";

import {MainComponent} from "./main/main.component";
import {AboutComponent} from "./about/about.component";
import {EducationComponent} from "./education/education.component";
import {PortfolioComponent} from "./portfolio/portfolio.component";
import {ContactComponent} from "./contact/contact.component";

export const AppRoutes:Routes = [
  {path: '', component: MainComponent},
  {path: 'about', component: AboutComponent},
  {path: 'education', component: EducationComponent},
  {path: 'portfolio', component: PortfolioComponent},
  {path: 'contact', component: ContactComponent},
  ];



// WEBPACK FOOTER //
// /Users/davcocom/Documents/Documents - David’s MacBook Pro/resume/resume-onepage/src/app/app.routes.ts